import React, { useEffect, useRef, useState } from "react"
import "./index.scss"
import { BaSeIcon } from "@base/react"

function Accordion({
                     title,
                     titleLength,
                     children,
                     forceHeightUpdate,
                     handleClick,
                     watch,
                   }) {
  const [active, setActive] = useState(false)
  const content = useRef(null)
  const [height, setHeight] = useState("0px")

  const updateHeight = () => {
    if (!content.current || !active) return

    requestAnimationFrame(() => {
      setHeight(`${content.current.scrollHeight}px`)
    })
  }

  const toggleAccordion = () => {
    setActive((prev) => {
      const nextActive = !prev

      if (nextActive) {
        requestAnimationFrame(() => {
          if (content.current) {
            setHeight(`${content.current.scrollHeight}px`)
          }
        })
      } else {
        setHeight("0px")
      }

      return nextActive
    })
  }

  const action = () => {
    if (handleClick) handleClick()
  }

  useEffect(() => {
    updateHeight()
  }, [forceHeightUpdate, watch, children])

  return (
    <div id="mp-accordion-section-driver-js" className="accordion-section">
      <div
        className={`accordion ${active ? "active" : ""}`}
        onClick={() => {
          action()
          toggleAccordion()
        }}
      >
        <span className="arrow">
          <figure
            style={{
              transform: `scale(${active ? "-1" : "1"})`,
              transition: "0.2s",
            }}
          >
            <BaSeIcon
              color="#617385"
              description="Menu"
              name="system/arrow-down-s-line"
              size={24}
            />
          </figure>
        </span>

        <p className="accordion-title">
          {title} ({titleLength})
        </p>
      </div>

      <div
        ref={content}
        style={{ maxHeight: height }}
        className={`accordion-content ${active ? "active" : ""}`}
      >
        {children}
      </div>
    </div>
  )
}

export default Accordion